import React from 'react';
import { Link } from "react-router-dom";

const Header = () => {
    return(
        <header className="App-header">
            <div className='App-logo'>
                <Link to='/'>
                    <img src={process.env.PUBLIC_URL + '/solvecube.png'} width="160px" alt="solve-cuve-hr"/>
                </Link>
            </div>
            <div className="option-container">
                <Link className="option" to='/analyzed-jd'>
                    View JDs
                </Link>
                <Link className="option" to='/analyzed-resumes'>
                    View Resumes
                </Link>
                <Link className="option" to='/post-requirement'>
                    Match Making
                </Link>
                <a href="https://console.cloud.google.com/natural-language/locations/us-central1/datasets/TEN9069753769780051968;modelId=TEN8065043134062526464/predict?project=solvecubehr" className="option" target="_blank">Try it on Cloud</a>
            </div>
        </header>
    )
};
export default Header;

